export const FILTER_CONFIGURATION = [
    {filterName: 'sport', eventPath: 'sport_id'},
    {filterName: 'status', eventPath: 'status_id'},
    {filterName: 'action', eventPath: 'action_id'}
];